import { useMemo } from 'react';
import { MenuTabs } from '~/components/ui/MenuTabs';
import { PanelControls } from '~/components/ui/PanelControls';
import { rage, useObservable } from '~/rage';
import { InputKey } from '~/shared';
import { useModal } from '../../hooks';
import {
	setActiveTab,
	showSaveModal,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { SavedTab } from '../SavedTab';
import { SettingsTab } from '../SettingsTab';
import { StyledControlsContainer } from './Handling.styled';

const Handling = () => {
	const tabs = ['Настройки', 'Сохраненные'];
	const dispatch = useLayoutDispatch();
	const activeTab = useLayoutSelector((state) => state.handling.activeTab);
	const menuTabsLocked = useLayoutSelector(
		(state) => state.tuningShop.menuTabsLocked,
	);
	const modalState = useObservable(rage.modal.getCurrentModal());
	const { handleSetupNewPresetModal, handleResetAllModal } = useModal();
	const handlePrevTab = () => {
		if (menuTabsLocked || modalState) {
			return;
		}

		dispatch(setActiveTab(activeTab === 0 ? 0 : activeTab - 1));
	};

	const handleNextTab = () => {
		if (menuTabsLocked || modalState) {
			return;
		}

		dispatch(
			setActiveTab(activeTab === tabs.length - 1 ? activeTab : activeTab + 1),
		);
	};

	const controls = useMemo(() => {
		if (activeTab !== 0) {
			return [
				{
					text: 'Сохранить настройку',
					keys: [InputKey.S],
					onClick: () => {
						dispatch(showSaveModal());
					},
				},
				{
					text: 'Сбросить настройку',
					keys: [InputKey.R],
					onClick: () => {
						handleResetAllModal();
					},
				},
			];
		}

		return [
			{
				text: 'Применить',
				keys: [InputKey.Enter],
				onClick: () => handleSetupNewPresetModal(),
			},
			{
				text: 'Сохранить настройку',
				keys: [InputKey.S],
				onClick: () => {
					dispatch(showSaveModal());
				},
			},
			{
				text: 'Сбросить настройку',
				keys: [InputKey.R],
				onClick: () => {
					handleResetAllModal();
				},
			},
		];
	}, [activeTab, handleSetupNewPresetModal, handleResetAllModal]);

	return (
		<div>
			<MenuTabs
				tabs={tabs}
				activeIndex={activeTab}
				handlePrev={handlePrevTab}
				handleNext={handleNextTab}
				setIndex={(index) => dispatch(setActiveTab(index))}
				style={{ marginTop: 20 }}
			/>
			{activeTab === 0 && <SettingsTab />}
			{activeTab === 1 && <SavedTab />}
			<StyledControlsContainer>
				<PanelControls controls={controls} align="left" />
			</StyledControlsContainer>
		</div>
	);
};

export { Handling };
